import { z } from 'zod';
import { isValidYMD } from '@/utils/date';

const orderItemSchema = z.object({
  id: z.number(),
  quantity: z.number({ message: '数値を入力してください' }).min(0, '数量は0以上で入力してください'),
  desired_delivery_date: z.string().nullable(),
});

export const orderDetailFormSchema = z
  .object({
    deliveryMode: z.enum(['date', 'asap']),
    desiredDeliveryDate: z.string(),
    notes: z.string(),
    items: z.array(orderItemSchema),
  })
  .superRefine((data, ctx) => {
    if (data.deliveryMode === 'date' && !data.desiredDeliveryDate) {
      ctx.addIssue({
        code: 'custom',
        message: '期日指定の場合は日付を指定してください',
        path: ['desiredDeliveryDate'],
      });
    }
    if (data.deliveryMode === 'date' && data.desiredDeliveryDate && !isValidYMD(data.desiredDeliveryDate)) {
      ctx.addIssue({
        code: 'custom',
        message: '日付の形式が正しくありません',
        path: ['desiredDeliveryDate'],
      });
    }
  });

export type OrderDetailForm = z.infer<typeof orderDetailFormSchema>;

const orderCreateItemSchema = z.object({
  product_variation_id: z.number(),
  quantity: z.number({ message: '数値を入力してください' }).min(0, '数量は0以上で入力してください'),
  desired_delivery_date: z.string().nullable(),
});

export const orderCreateFormSchema = z
  .object({
    deliveryMode: z.enum(['date', 'asap']),
    desiredDeliveryDate: z.string(),
    notes: z.string(),
    items: z.array(orderCreateItemSchema),
  })
  .superRefine((data, ctx) => {
    if (data.deliveryMode === 'date' && !data.desiredDeliveryDate) {
      ctx.addIssue({
        code: 'custom',
        message: '期日指定の場合は日付を指定してください',
        path: ['desiredDeliveryDate'],
      });
    }
    if (data.deliveryMode === 'date' && data.desiredDeliveryDate && !isValidYMD(data.desiredDeliveryDate)) {
      ctx.addIssue({
        code: 'custom',
        message: '日付の形式が正しくありません',
        path: ['desiredDeliveryDate'],
      });
    }
  });

export type OrderCreateForm = z.infer<typeof orderCreateFormSchema>;

export interface OrderFormBase {
  deliveryMode: 'date' | 'asap';
  desiredDeliveryDate: string;
  notes: string;
  items: Array<{ quantity: number; desired_delivery_date: string | null }>;
}
